import {Inject, Injectable} from '@angular/core';
import {BehaviorSubject, EMPTY, Observable, Subject} from 'rxjs';
import {catchError, switchAll} from 'rxjs/operators';
import {webSocket, WebSocketSubject} from 'rxjs/webSocket';
import {TISA_UMPIRE_URL} from '../tisa-umpire.providers';

@Injectable()
export class CableService<T> {
  private _socket$: WebSocketSubject<T> | undefined;

  readonly messagesSubject$ = new Subject<Observable<T>>();

  readonly messages$ = this.messagesSubject$.pipe(
    switchAll(),
    catchError(e => {
      throw e;
    }),
  );

  readonly connected$ = new BehaviorSubject<boolean>(false);

  constructor(@Inject(TISA_UMPIRE_URL) readonly umpireUrl: string) {}

  sendMessage<M>(msg: M): void {
    let payload: any;

    if (typeof msg === 'object') {
      payload = {...msg} as any;

      if (payload.identifier) {
        payload.identifier = JSON.stringify(payload.identifier);
      }
    } else {
      payload = msg;
    }

    this._socket$?.next(payload);
  }

  connect(): void {
    if (!this._socket$ || this._socket$.closed) {
      this._socket$ = this._getNewWebSocket();

      const messages: Observable<T> = this._socket$.pipe(catchError(_ => EMPTY));

      this.messagesSubject$.next(messages);
      this.connected$.next(true);
    }
  }

  disconnect(): void {
    this._socket$?.complete();
    this._socket$?.unsubscribe();
    this.connected$.next(false);
  }

  private _getNewWebSocket(): WebSocketSubject<T> {
    return webSocket<T>(`${this.umpireUrl.replace('https', 'wss')}/cable`);
  }
}
